var Menu = Chaplin.Model.extend({
  path: function() {
    return this.get('key');
  }
});

module.exports = Menu;
